{
  "header": {
    "nav": {
      "manifesto": "Manifesto",
      "insights": "Perspectives",
      "services": "What We Do",
      "solutions": "Solutions",
      "about": "About",
      "cases": "Cases"
    },
    "contact": "Orchestrate Agents"
  },
  "hero": {
    "heading1": "Enterprise AI Agent",
    "heading2": "Orchestration",
    "description": "We understand your company's operation, build agents connected to your systems, and stay close until AI becomes a real part of the company's routine, generating measurable results.",
    "cta": "How it works",
    "manifesto": "Manifesto",
    "kicker": "For complex operations, high process volume, and teams that need to gain efficiency.",
    "proof": "Agents running in production at your company in less than 4 weeks."
  },
  "valueProposition": {
    "items": [
      {
        "title": "Enterprise Agent Platform",
        "description": "Proprietary, model-agnostic platform. We continuously evaluate Anthropic, OpenAI, Google, and many other models for each use case. You are not locked into any provider. We adjust models without rewriting the agent — always aiming for maximum results."
      },
      {
        "title": "Assessment → Build → Operate",
        "description": "A complete cycle to put AI agents in production, with security, control, and adherence to your compliance.\nWe understand where AI truly makes sense, design the orchestration aligned with processes, systems, and requirements, and follow through after implementation."
      },
      {
        "title": "Embedded Agent Engineer",
        "description": "A senior professional (60% technical, 40% business) inside your operation. Refines agents, maintains integrations, manages incidents, ensures security, and optimizes token cost. Not an allocated dev. Not a distant consultant. It's technical and operational ownership over the AI in production at your company."
      }
    ]
  },
  "services": {
    "label": "Operating Model",
    "heading": "From diagnosis to continuous operation.",
    "description": "Three phases. One cycle. Operate is the heart: shipping an agent to production is the start, not the end.",
    "explore": "Learn more",
    "cta": {
      "description": "Start with the Assessment and discover where AI can generate real value in your operation.",
      "button": "Book your Assessment"
    },
    "items": [
      {
        "title": "Assessment",
        "description": "Detailed diagnosis of your operation. Executive deliverables: AI Score (maturity map), automatable-task matrix, agent architecture by function, integrations analysis, risk matrix, and business case with estimated ROI. Low-risk entry point — you walk away with an executable plan for implementing AI agents shaped to your operation."
      },
      {
        "title": "Build",
        "description": "Engineering and implementation of the agents on the Bravic Platform, integrated with your ERP, CRM, and any internal system. You receive agents in production with sandbox, observability, human fallback, and team training. We make sure AI goes into production with control, not as a loose experiment."
      },
      {
        "title": "Operate",
        "description": "Continuous operation with embedded Agent Engineer at your company. Refinement, maintenance, incident management, token-cost optimization, evolution alongside the business. Models change, systems evolve, rules shift, exceptions appear. Without continuous operation, any agentic system degrades within weeks. Operate is where intelligence operates connected to your operation."
      }
    ]
  },
  "stats": {
    "items": [
      {
        "value": "144h/mo",
        "label": "Operational hours eliminated in Scoder's monthly closing"
      },
      {
        "value": "38 → 97%",
        "label": "Service-record rate at JHSF Participações"
      },
      {
        "value": "≤ 4 wk",
        "label": "From Assessment to first agent in production"
      },
      {
        "value": "0",
        "label": "Provider lock-in. Model-agnostic platform."
      }
    ]
  },
  "insights": {
    "label": "Perspectives",
    "heading": "Understand how we think.",
    "readMore": "Read article",
    "articles": [
      {
        "slug": "value-not-in-tool",
        "category": "Analysis · Market",
        "title": "Why the value isn't in the AI tool",
        "description": "Platforms will commoditize. Models will commoditize. What does not commoditize is understanding the problem, building the right solution, and operating it continuously. Whoever masters the process captures the market."
      },
      {
        "slug": "agents-without-operation",
        "category": "Operation",
        "title": "What happens to agents without continuous operation",
        "description": "Models get updated. APIs deprecate. Business rules change. Exceptions appear. Without someone embedded refining prompts, maintaining integrations, and optimizing cost, the agentic system becomes a silent liability — and you only notice when the bill arrives."
      },
      {
        "slug": "orchestration-is-the-product",
        "category": "Architecture",
        "title": "Orchestration is the product. The agent is a part.",
        "description": "When agents stop being isolated tools, competitive advantage moves to the layer that decides who does what, when, with which context, and under which rule."
      }
    ]
  },
  "cases": {
    "label": "Where we made AI stop being a promise",
    "heading": "What we've delivered.",
    "description": "Each implementation shows how Bravic transforms opportunities mapped in the Assessment into agents running in the company's routine — with security, clarity, and aligned with compliance.",
    "viewCase": "View case",
    "items": [
      {
        "category": "OPERATIONAL AUTOMATION · SOFTWARE HOUSE",
        "title": "Monthly hours closing with electronic invoice issuance",
        "description": "144 hours/month eliminated. Process reduced from 7 days to 1. Full cycle of accounting, validation, billing, and payment for project-allocated professionals, integrated with Jira, Sheets, Slack, Drive, Banco Inter, and the municipal e-invoicing API. Delivered to Scoder Tech Studio via Sugar Cane Tech.",
        "href": "/case-scoder"
      },
      {
        "category": "CRM & LEAD SCORING · REAL ESTATE",
        "title": "Smart lead enrichment via brokers and clients",
        "description": "Service-record rate rose from 38% to 97%. Mean update time fell from 3-5 days to under 4 hours. Broker feedback collection by audio plus post-visit client survey, integrated with Salesforce with automatic score recalculation. Delivered to JHSF Participações via Sugar Cane Tech.",
        "href": "/case-jhsf"
      }
    ]
  },
  "cta": {
    "heading": "Enterprise AI Agent Orchestration",
    "description": "The next operational advantage won't come from another tool. It will come from the ability to put AI to work inside the company, with security, governance, and clarity of execution.\n\nBravic helps companies cross that path: from diagnosis to operation, with agents connected to systems, processes, and business rules.\n\nStart with the Assessment and discover where AI can generate real value in your operation.",
    "button": "Talk to Bravic"
  },
  "footer": {
    "description": "From strategy to production, with AI agents connected to your company's systems, processes, and rules.",
    "deliveryLayers": "Operating Model",
    "institutional": "Institutional",
    "globalHq": "Contact",
    "practiceAreas": ["Assessment", "Build", "Operate", "Bravic Platform"],
    "institutionalLinks": ["Manifesto", "Privacy Policy", "Terms of Service"],
    "address": {
      "line1": "São Paulo, SP - Brazil",
      "line2": "",
      "phone": "+55 (35) 99975-3380",
      "email": "contact@bravicglobal.com"
    },
    "copyright": "© {{year}} Bravic. All rights reserved.",
    "offices": ["Brazil"],
    "manifesto": "Enterprise AI Agent Orchestration"
  },
  "manifesto": {
    "hero": {
      "subtitle": "Bravic Manifesto",
      "heading": "INTELLIGENCE THAT OPERATES.",
      "headingLine1": "ORCHESTRATION",
      "headingLine2": "OF",
      "headingHighlight": "AI AGENTS.",
      "quote": "The value isn't in the AI tool. It's in understanding the problem, building the right solution, and operating it continuously — with measurable results.",
      "statement": "We don't sell platforms. We don't deliver reports with recommendations. We build agents in production and operate alongside the client, every day."
    },
    "thesis": {
      "title": "The Thesis",
      "box1": "Every company will need AI agents. Most won't be able to implement them on their own — safely, efficiently, and with measurable results.",
      "box2": "That gap between \"wanting AI\" and \"having AI working\" is Bravic's territory. Neither tool without business context nor consulting without execution. Understanding of the problem, technical capability of delivery, and continuous operation alongside the client — all three, together.",
      "narrative1": "The market is saturated with generic AI tools. The list grows weekly. Platforms sell technical capability, charge per seat, and leave the client alone to figure out how to apply it. That works for those with internal technical teams. It does not work for 90% of the mid-market. Traditional consultancies solve the other half halfway: they deliver strategy without execution. The report stays in the drawer. The agents never arrive.",
      "immutableTitle": "Operate is the heart",
      "immutableText": "Shipping an agent to production is the start, not the end. Models get updated. Client systems get redeployed. Business rules change. Exceptions appear. Without continuous operation, any agentic system degrades within weeks. The embedded Agent Engineer is what keeps the agents alive while the business transforms — and what separates an abandoned experiment from a living operation.",
      "narrative2": "Three premises sustain the thesis. First: demand will keep growing. Second: tools will commoditize — the differentiator won't be which one is used, but how it is used. Third: a replicable method, documented well enough to be taught, is what combines delivery quality with capacity to scale. Consulting doesn't scale because it depends on the same people. SaaS scales but doesn't solve the client's problem. A documented framework combines both.",
      "principleLabel": "Fundamental Principle",
      "principleText": "Tools will commoditize. Whoever masters the implementation and operation process captures the market."
    },
    "briefings": {
      "title": "HOW WE WORK",
      "viewAll": "Learn the framework",
      "featured": {
        "category": "Framework",
        "title": "Assessment → Build → Operate",
        "link": "SEE THE FULL MODEL"
      },
      "internal": {
        "category": "Differentiator",
        "title": "Embedded Agent Engineer",
        "description": "A senior professional, 60% technical and 40% business. Inside the client's operation until the agents are in production delivering measurable results — and after. Not an allocated dev. Not a distant consultant. The bridge between the real problem and the agent in production."
      },
      "case": {
        "label": "Platform",
        "title": "Enterprise Agent Platform",
        "description": "Proprietary and model-agnostic. We continuously evaluate Anthropic, OpenAI, Google, and open-source models for each use case. No lock-in. No rewriting the agent to switch models."
      },
      "event": {
        "label": "Compliance",
        "title": "Diagnosis, build, and continuous operation, with control, security, and compliance alignment to your company."
      }
    },
    "cta": {
      "heading": "READY TO START?",
      "description": "Start with the Assessment. Strategic diagnosis with AI Score, executive roadmap, and estimated ROI. Low-risk entry point — you walk away with an executable plan, even if you decide not to move on to Build.",
      "requestConsulting": "Schedule an Assessment",
      "downloadCapabilities": "Institutional Document"
    }
  },
  "contact": {
    "hero": {
      "subtitle": "Contact",
      "headingLine1": "START WITH THE",
      "headingHighlight": "ASSESSMENT.",
      "description": "We don't sell hours. We don't sell tools. We work with companies willing to turn entire operational areas into supervised agentic operations — with measurable results within the first months."
    },
    "form": {
      "label": "Form",
      "heading": "Start the Conversation.",
      "description": "Fill in the fields below. One of the founders will reach out within 24 hours to map your operational landscape.",
      "nameLabel": "Full Name",
      "namePlaceholder": "Your name",
      "emailLabel": "Corporate Email",
      "emailPlaceholder": "name@company.com",
      "companyLabel": "Company",
      "companyPlaceholder": "Company name",
      "serviceLabel": "Area of Interest",
      "servicePlaceholder": "Select an area",
      "services": [
        {
          "label": "Assessment — Strategic Diagnosis",
          "value": "diagnostics"
        },
        {
          "label": "Build — Engineering and Implementation",
          "value": "orchestration"
        },
        {
          "label": "Operate — Continuous Operation",
          "value": "implementation"
        },
        {
          "label": "Full A → B → O Cycle",
          "value": "continuous"
        },
        {
          "label": "Initial Conversation",
          "value": "consulting"
        }
      ],
      "messageLabel": "Message",
      "messagePlaceholder": "Briefly describe the operational challenge you're looking to solve.",
      "submitButton": "Send Message",
      "sendingButton": "Sending...",
      "successHeading": "Message sent.",
      "successMessage": "One of the founders will analyze your scenario and reach out within 24 hours.",
      "errorMessage": "Error sending message. Please write to us directly at contact@bravicglobal.com"
    },
    "info": {
      "label": "Direct Channels",
      "heading": "Other Ways to Reach Us",
      "items": [
        {
          "icon": "mail",
          "title": "Email",
          "line1": "contact@bravicglobal.com",
          "line2": ""
        },
        {
          "icon": "phone",
          "title": "Phone",
          "line1": "+55 (35) 99975-3380",
          "line2": ""
        },
        {
          "icon": "location_on",
          "title": "Office",
          "line1": "São Paulo, SP - Brazil",
          "line2": ""
        }
      ]
    }
  },
  "about": {
    "hero": {
      "subtitle": "Who we are",
      "headingLine1": "WE TRANSFORM",
      "headingHighlight": "COMPANIES.",
      "description": "Senior engineering applied to enterprise AI agent orchestration. Diagnosis, build, and continuous operation — with control, security, and compliance alignment to your company.",
      "statement": "Every claim here is backed by method, data, or experience. Clarity as a sign of competence."
    },
    "principles": {
      "label": "Principles",
      "heading": "What Guides Us",
      "items": [
        {
          "icon": "verified_user",
          "title": "Backed by Data",
          "description": "Every claim anchored in method, number, or real experience. No promise we cannot defend in a room with your CFO."
        },
        {
          "icon": "architecture",
          "title": "Senior Engineering",
          "description": "Knowing how to build and how to deliver. Technical depth combined with a track record of client relationships, scope negotiation, and expectation management in enterprise environments."
        },
        {
          "icon": "engineering",
          "title": "Embedded Operation",
          "description": "We are not distant consultants. The Agent Engineer stays inside the client's operation until the agents are in production with control, security, and measurable results — and continues afterwards, refining, integrating, optimizing."
        },
        {
          "icon": "loop",
          "title": "Replicable Framework",
          "description": "Each Assessment, Build, and Operate is documented as if it were being taught to another person. A replicable method is what combines delivery quality with capacity to scale."
        }
      ]
    },
    "team": {
      "label": "Founders",
      "heading": "Who Builds Bravic",
      "members": [
        {
          "name": "Filipe Campos",
          "role": "Co-founder",
          "bio": "Software engineer and entrepreneur with 18+ years of experience. Led complex projects in banking, energy, retail, and digital services. Built and scaled a software company with more than 30 engineers before Bravic."
        },
        {
          "name": "Brunno Romero",
          "role": "Co-founder",
          "bio": "Software engineer and AI advisor to large companies in Brazil and abroad, with 15+ years of experience. Specialist in data architecture for LLM training and leading integration teams — focused on deploying AI in real production environments, not in the lab."
        }
      ]
    },
    "locations": {
      "label": "Operation",
      "heading": "Where We Are",
      "items": [
        {
          "number": "01",
          "city": "São Paulo · Campinas",
          "title": "Headquarters and operation",
          "description": "Founding team based in São Paulo and Campinas. Active pilots in the field. Lean operation — by choice, not by constraint."
        }
      ]
    },
    "cta": {
      "heading": "Start with the Assessment.",
      "description": "Strategic diagnosis with AI Score, executive roadmap, and estimated ROI. Low-risk entry point — you walk away with an executable plan, even if you decide not to move on to Build.",
      "primaryButton": "Schedule an Assessment",
      "secondaryButton": "View Cases"
    }
  },
  "articlePage": {
    "backLabel": "Perspectives",
    "keyInsight": "Central thesis",
    "takeaways": "Key points",
    "relatedMetrics": "In summary",
    "ctaHeading": "Start with the Assessment.",
    "ctaDescription": "Strategic diagnosis with AI Score, roadmap, and estimated ROI. Low-risk entry point — you walk away with an executable plan, even if you decide not to move on to Build.",
    "ctaButton": "Talk to Bravic"
  },
  "articlePages": [
    {
      "slug": "value-not-in-tool",
      "category": "Analysis · Market",
      "title": "Why the value isn't in the AI tool",
      "subtitle": "Platforms will commoditize. Models will commoditize. The differentiator will be how you understand the problem, build the right solution, and operate it continuously.",
      "readTime": "5 min read",
      "keyInsight": "Every company will need agents. Most won't be able to implement them on their own — safely, efficiently, and with measurable results. That gap between 'wanting AI' and 'having AI working' is the real territory of value capture.",
      "content": [
        "The market is saturated with generic AI tools. The list grows weekly. Each one promises to make agent-building easy. For those with internal technical teams, maybe. For 90% of the mid-market, it's just one more layer of complexity nobody has time to master.",
        "There's a gap that grows with every new model release: the distance between knowing AI is necessary and being able to implement it safely, efficiently, with measurable results. Platforms sell technical capability and charge per seat or execution. Traditional consultancies deliver reports with recommendations. The client ends up with a document and zero agents in production.",
        "Bravic's thesis is simple. Tools will commoditize. Agent platforms will get cheaper and more similar to each other, at the same speed models get more capable and more interchangeable. The differentiator won't be which tool. It will be how it is used.",
        "Whoever captures sustainable value combines three things: understanding of the client's problem, technical capability to deliver, and continuous operation alongside them. It is the only position that isn't easily commoditized — because it depends on method, not on technology.",
        "The moat builds with each client. Which prompts work for each kind of process. Which integrations break and why. Which exception patterns appear by sector. How to optimize cost per token in each case. That operational knowledge appreciates every month. And no new entrant can replicate it without the same time in the field."
      ],
      "takeaways": [
        {
          "icon": "hub",
          "title": "Tool isn't the differentiator",
          "description": "Platforms will commoditize. What sustains value is understanding the problem, building it right, and operating it continuously."
        },
        {
          "icon": "engineering",
          "title": "Method is the moat",
          "description": "A replicable framework combining diagnosis, engineering, and operation is what scales without losing quality."
        },
        {
          "icon": "visibility",
          "title": "Operation accumulates data",
          "description": "Every month of Operate generates proprietary operational knowledge — an asset that appreciates over time."
        }
      ],
      "metrics": [
        {
          "value": "A→B→O",
          "label": "Single Bravic cycle"
        },
        {
          "value": "Embedded",
          "label": "Agent Engineer at the client"
        },
        {
          "value": "Recurring",
          "label": "Operation, not project"
        },
        {
          "value": "Model-agnostic",
          "label": "No provider lock-in"
        }
      ]
    },
    {
      "slug": "agents-without-operation",
      "category": "Operation",
      "title": "What happens to agents without continuous operation",
      "subtitle": "\"Deploy once, forget forever\" is the most expensive myth in applied AI. An agentic system without someone embedded degrades within weeks.",
      "readTime": "6 min read",
      "keyInsight": "Shipping an agent to production is the start, not the end. Models change, systems evolve, processes adjust, exceptions appear. Without continuous operation, any agentic system becomes a silent liability — and you only notice when the bill arrives.",
      "content": [
        "The easy promise: configure an agent once and let it run. The technical reality: AI models get updated, APIs deprecate, business rules change, the client's operational context transforms. What does not change on its own is the agent. That's the problem.",
        "Without someone embedded refining prompts, maintaining integrations, managing incidents, and optimizing token cost, deviations accumulate in silence. Exception cases appear by sector and nobody adjusts the rules. Integrations break when the client's system gets a deploy. Cost per task creeps up without anyone noticing — until the bill arrives.",
        "Operate is the heart of the Bravic model for an objective reason: it is what separates abandoned experiments from living operations. It isn't reactive maintenance. It's continuous supervision, refinement, cost optimization, evolution alongside the client's business. Bi-weekly meetings. Monthly report. Prompt and integration adjustments as the client changes.",
        "The embedded Agent Engineer is the central piece. Senior hybrid professional — 60% technical, 40% business — who lives inside the client's operation every day. In many cases, understands the infrastructure better than the internal team. Not because the AE is smarter. Because that is the only thing the AE thinks about.",
        "The right question to ask any AI vendor isn't how much they deliver at go-live. It's who keeps the system running afterwards — and how much that costs in three, six, twelve months."
      ],
      "takeaways": [
        {
          "icon": "engineering",
          "title": "Operate ≠ maintenance",
          "description": "It's refinement, evolution, cost optimization, and incident management — the backbone of a living agentic operation."
        },
        {
          "icon": "person",
          "title": "Embedded Agent Engineer",
          "description": "Senior hybrid professional living inside the client's operation. Not an allocated dev. Not a distant consultant."
        },
        {
          "icon": "savings",
          "title": "Cost per token matters",
          "description": "Without supervision, token cost inflates. The difference between expensive and efficient operation is the Operate layer."
        }
      ],
      "metrics": [
        {
          "value": "Embedded",
          "label": "In the client's operation"
        },
        {
          "value": "Senior",
          "label": "60% technical · 40% business"
        },
        {
          "value": "Continuous",
          "label": "24/7 AE supervision"
        },
        {
          "value": "Monthly",
          "label": "Efficiency report"
        }
      ]
    },
    {
      "slug": "orchestration-is-the-product",
      "category": "Architecture",
      "title": "Orchestration is the product. The agent is a part.",
      "subtitle": "When agents stop being isolated tools, competitive advantage moves to the layer that decides who does what, when, with which context, and under which rule.",
      "readTime": "7 min read",
      "keyInsight": "A single agent is a demo. A fleet of agents without orchestration is chaos dressed as innovation. The layer that coordinates them — routes tasks, holds shared memory, arbitrates conflict, enforces policy — is where enterprise software will be won or lost over the next decade.",
      "content": [
        "For years, the enterprise AI conversation revolved around the agent as lone hero. A copilot here. An assistant there. Every department bought its own, every vendor packaged its own, and each one operated as an island. It worked for demos. It does not work for real operations. The moment a decision crosses three departments, seven systems, and eighteen compliance rules, the lone agent stalls — or worse, decides wrong with confidence.",
        "The leap that matters now is not training smarter agents. It is building the layer that makes several agents work as one system. Task routing. Shared memory. Conflict arbitration. Policy and audit. That layer has a name: orchestration. And it is becoming what databases were in the 1980s and what APIs were in the 2000s — the quiet infrastructure that separates the companies that operate from the ones that merely demo.",
        "There is a practical difference between automation and agentic operation that few executives articulate cleanly. Automation runs a deterministic flow that someone designed in advance. Agentic operation delegates the design of the flow to the system itself, within boundaries the business defines. The first model scales poorly because it needs a human for every exception. The second scales because it treats the exception as the common case. Orchestration is what makes the second model possible without turning into a black box.",
        "Architecting this demands decisions that do not fit on slides. Who is the source of truth when two agents disagree? How does one agent pass context to another without leaking data it should not? Where does long-term memory live, and who decides what to forget? Which actions can an agent take alone, and which ones require human approval? These are not technical questions — they are governance ones. Whoever answers them before writing code avoids rewriting it later. Whoever answers later finds out, in the audit, that they answered wrong.",
        "The CTO who grasps this first will stop buying agents and start designing the layer that coordinates them. What used to be a stack of tools becomes the operating system of work. And like every operating system, the winner is not the one with the most features — it is the one with the cleanest mental model of how agents, data, people, and rules coexist. The next decade of enterprise software does not belong to the smartest agent. It belongs to the orchestra that conducts it."
      ],
      "takeaways": [
        {
          "icon": "hub",
          "title": "Orchestration is the new layer",
          "description": "Competitive advantage has moved from the individual agent to the system that coordinates multiple agents, data, and policy in real time."
        },
        {
          "icon": "account_tree",
          "title": "Agentic operation, not automation",
          "description": "Automation runs pre-designed flows. Agentic operation delegates flow design to the system, within boundaries the business defines."
        },
        {
          "icon": "policy",
          "title": "Governance before code",
          "description": "Source of truth, memory, autonomy, and human approval are governance decisions. Answer them early or rewrite later."
        }
      ],
      "metrics": [
        {
          "value": "Layer",
          "label": "Orchestration as infrastructure, not feature"
        },
        {
          "value": "System",
          "label": "Many agents coordinated, not isolated"
        },
        {
          "value": "Policy",
          "label": "Business rules enforced at runtime"
        },
        {
          "value": "Autonomy",
          "label": "Clear boundary between human and agentic decision"
        }
      ]
    }
  ],
  "roadmap": {
    "hero": {
      "headingLine1": "Assessment → Build →",
      "headingLine2": "Operate.",
      "description": "Three phases. One cycle. From diagnosis to continuous agent operation — with control, security, and compliance alignment. Operate is the heart: shipping an agent to production is the start, not the end."
    },
    "phase01": {
      "label": "Phase 01 · Assessment",
      "title": "Strategic Diagnosis",
      "quote": "Precision in diagnosis is the antidote to operational friction.",
      "description": "",
      "cards": [
        {
          "icon": "account_tree",
          "title": "Process Mapping",
          "description": "High-fidelity map of the current operational process and data flows — from executive level down to the operation."
        },
        {
          "icon": "grid_guides",
          "title": "Automation Matrix",
          "description": "Matrix identifying and prioritizing automatable tasks by impact, effort, and technical feasibility."
        },
        {
          "icon": "smart_toy",
          "title": "Agent Role Design",
          "description": "Agent architecture defined by specific operational role — not one generic agent, several specialized ones."
        },
        {
          "icon": "security",
          "title": "Governance Matrix",
          "description": "Risk assessment and compliance framework calibrated to your sector and your data profile."
        },
        {
          "icon": "calculate",
          "title": "Business Case",
          "description": "Financial modeling with projected savings, SLA, and throughput — before any investment in build."
        },
        {
          "icon": "hub",
          "title": "Required Integrations",
          "description": "Blueprint of the integrations required: ERP, CRM, internal systems, external APIs. Where they are, how they connect."
        }
      ]
    },
    "phase02": {
      "label": "Phase 02 · Build",
      "title": "Engineering and Implementation",
      "description": "Custom agents built on the Bravic Platform, integrated with your ERP, CRM, and any internal system. Sandbox, observability, human fallback, and team training. AI goes into production with control, not as a loose experiment.",
      "metric": "Platform",
      "metricLabel": "Proprietary and model-agnostic",
      "features": [
        {
          "icon": "check_circle",
          "title": "Tailored Agent Deployment",
          "description": "Agents designed for your business logic — not adjusted templates."
        },
        {
          "icon": "monitoring",
          "title": "Observability Dashboard",
          "description": "Real-time telemetry on every agentic interaction: latency, cost, quality, exceptions."
        },
        {
          "icon": "menu_book",
          "title": "Human Fallback Playbooks",
          "description": "Clear protocols for when the agent should hand a task to a human — and how that handoff happens."
        },
        {
          "icon": "school",
          "title": "Client Training",
          "description": "Executive and technical workshops. Your team understands the system, not just uses it."
        }
      ]
    },
    "phase03": {
      "label": "Phase 03 · Operate",
      "title": "Continuous Operation",
      "description": "Operate is the heart of the model. Embedded Agent Engineer at your company, continuous refinement, incident management, token-cost optimization, and evolution alongside the business. Models change, systems evolve, rules shift, exceptions appear. Without continuous operation, any agentic system degrades within weeks. Operate is where intelligence operates connected to your operation.",
      "cards": [
        {
          "icon": "engineering",
          "title": "Dedicated Agent Engineer",
          "description": "A dedicated or shared engineer for adjustments, maintenance, and evolution. The person who knows your operation."
        },
        {
          "icon": "query_stats",
          "title": "Quality Monitoring",
          "description": "Continuous supervision of agent quality and behavior — to catch drift before it costs you money."
        },
        {
          "icon": "savings",
          "title": "Cost Optimization",
          "description": "Granular refinement of token usage and per-task expense. What was expensive becomes efficient."
        },
        {
          "icon": "refresh",
          "title": "Workflow Reviews",
          "description": "Periodic review of rules and workflows to adapt to changes in the business. The agent keeps up with the company."
        },
        {
          "icon": "trending_up",
          "title": "System Evolution",
          "description": "Continuous evaluation of new models. When a better one appears, the agent migrates. Without rewriting."
        },
        {
          "icon": "hub",
          "title": "Infrastructure Health",
          "description": "Proactive management of every integration and underlying API. When your system changes, the agent knows."
        }
      ]
    },
    "cta": {
      "heading": "Start with the Assessment.",
      "description": "Strategic diagnosis with AI Score, executive roadmap, and estimated ROI. Low-risk entry point — you walk away with an executable plan, even if you decide not to move on to Build.",
      "primaryButton": "Schedule an Assessment"
    }
  },
  "institucional": {
    "title": "Institutional Document",
    "year": "2026",
    "tagline": "Your operation, <strong>operated with AI.</strong>",
    "subtitle": "Institutional Document",
    "byLine": "by Sugar Cane Tech",
    "whoWeAre": {
      "title": "Who We Are",
      "paragraphs": [
        "<strong>Sugar Cane Tech</strong> is a software house with <strong>6+ years of experience</strong> and <strong>30+ projects delivered</strong>, building software across multiple industries and levels of complexity.",
        "We specialize in allocating <strong>top Brazilian engineering talent</strong> to companies in <strong>Europe and the United States</strong>, while also delivering end-to-end custom software projects — with strong experience in the <strong>insurance sector</strong>.",
        "<strong>Bravic is built on top of this foundation.</strong>",
        "<strong>Bravic</strong> is the AI platform and intelligence arm of <strong>Sugar Cane Tech</strong>, focused on helping companies actually <strong>operate with AI</strong> — not just experiment with it. It was founded by engineers with deep experience in building and scaling software businesses.",
        "<a href=\"https://www.linkedin.com/in/filipecps\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>Filipe Campos</strong></a> is a software engineer and entrepreneur with <strong>18+ years of experience</strong>. He has led complex projects across banking, energy, retail, and digital services, and previously built and scaled a software company with <strong>30+ engineers</strong>.",
        "<a href=\"https://www.linkedin.com/in/brunno-romero\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>Brunno Romero</strong></a> is a software engineer and AI advisor to large companies in Brazil and abroad, with <strong>15+ years of experience</strong>. He specializes in data architecture for LLM training and leading integration teams, focusing on deploying AI in <strong>real-world, production environments</strong>.",
        "We work <strong>hands-on</strong> with companies to identify high-impact opportunities, implement AI workflows, and embed intelligence into their day-to-day operations.",
        "Our approach is simple: <strong>short cycles, fast delivery, and real results within weeks</strong>."
      ]
    },
    "problem": {
      "title": "The Problem",
      "subtitle": "What we discovered talking with several companies",
      "intro": "In recent months, we've spoken with companies of different sizes and industries about how they're adopting artificial intelligence. What we found was a <strong>clear pattern</strong>: almost all are trying to use AI — but in <strong>disconnected, unscalable ways — without a strategy</strong> that delivers lasting results. The same problems keep coming up:",
      "items": [
        {
          "title": "Isolated initiatives, no big picture",
          "description": "Each department tries to solve its own problem with AI, but nobody connects the dots. The result is scattered tools, duplicated effort, and zero synergy."
        },
        {
          "title": "Automations that don't scale",
          "description": "Many companies automate one-off tasks, but without an architecture designed to grow. When demand increases, everything breaks."
        },
        {
          "title": "Data trapped in silos",
          "description": "AI needs data — but it's scattered across systems that don't talk to each other. Without integration, any model delivers less than it could."
        },
        {
          "title": "Results nobody can measure",
          "description": "AI projects are launched without clear impact metrics. If you can't measure it, you can't justify the investment — or improve."
        },
        {
          "title": "Lack of standardization and governance",
          "description": "Each team uses AI differently, without quality, security, or compliance standards. This creates hidden, compounding risk."
        },
        {
          "title": "Real risk of data leakage",
          "description": "With the growing use of generative AI, sensitive corporate data gets exposed — and few companies have clear policies to prevent it."
        }
      ]
    },
    "whatWeDo": {
      "title": "What We Do",
      "subtitle": "Our 3 pillars of action",
      "intro": "After implementing AI across different companies and contexts, we kept seeing the same challenges: lack of clarity on where AI generates value, systems not ready to connect with agents, and automations built without structure to scale. From these patterns, we built a <strong>repeatable 3-step framework</strong> — designed to take any company from diagnosis to real automation, fast, with measurable results, and no platform lock-in.",
      "pillars": [
        {
          "num": "01",
          "engTitle": "Assessment",
          "ptTitle": "Strategic Diagnosis",
          "description": "We map processes, identify bottlenecks, and design the agent architecture with validated technical and financial feasibility. Primary deliverable: AI Score, with the AI Maturity Scale as a component."
        },
        {
          "num": "02",
          "engTitle": "Build",
          "ptTitle": "Implementation",
          "description": "We connect your systems via MCP, build and deploy custom agents on our own platform — all alongside your team."
        },
        {
          "num": "03",
          "engTitle": "Operate",
          "ptTitle": "Continuous Operations",
          "description": "Monitoring, cost optimization, agent evolution, and dedicated support so your AI operations never stop improving."
        }
      ]
    },
    "discovery": {
      "label": "01  —  ASSESSMENT",
      "paragraphs": [
        "We use structured questionnaires to map the <strong>company's processes</strong>. Starting at the C-suite level, the questionnaire cascades through every relevant department — all insights generated <strong>belong entirely to you</strong>.",
        "After the questionnaire is completed, we conduct a <strong>joint analysis between our consultants and operations leaders</strong> to assign weights, set priorities, and identify the outcomes that unlock automation. Important: AI isn't always the answer — sometimes a <strong>simple automation is faster and cheaper</strong> — and we'll be upfront about it.",
        "This process also helps us understand where the company stands through our <strong>AI Maturity Scale</strong>:"
      ],
      "maturityLevels": [
        {
          "level": 1,
          "zone": "risk",
          "title": "Awareness",
          "description": "Knows AI is important, but nothing has changed."
        },
        {
          "level": 2,
          "zone": "risk",
          "title": "Shadow AI",
          "description": "Employees using AI individually, without standards."
        },
        {
          "level": 3,
          "zone": "risk",
          "title": "Standardization",
          "description": "Rules in place, risk reduced, but no real transformation."
        },
        {
          "level": 4,
          "zone": "transition",
          "title": "AI in Processes",
          "description": "AI in workflows, but humans still do the work."
        },
        {
          "level": 5,
          "zone": "transition",
          "title": "Business Awareness",
          "description": "AI accesses internal data and understands business context."
        },
        {
          "level": 6,
          "zone": "automation",
          "title": "Supervised Autonomy",
          "description": "AI executes, humans supervise."
        },
        {
          "level": 7,
          "zone": "automation",
          "title": "AI Teams by Function",
          "description": "Each department has its own agents. Roles evolve."
        },
        {
          "level": 8,
          "zone": "automation",
          "title": "Unified Intelligence",
          "description": "AI systems connected across departments, sharing intelligence."
        },
        {
          "level": 9,
          "zone": "automation",
          "title": "Continuous Feedback",
          "description": "AI learns, adapts, and evolves with the business."
        }
      ],
      "maturityLabels": {
        "risk": "Risk (1-3)",
        "transition": "Transition (4-5)",
        "automation": "Automation (6-9)"
      },
      "closing": [
        "Beyond the mapping, the Assessment includes a <strong>technical and financial feasibility analysis</strong> of each agent or automation: we estimate <strong>token costs</strong>, select the <strong>best-fit models</strong>, and project the <strong>operational expense</strong> for each solution. This lets us confirm whether each automation is viable — before you invest in building it.",
        "With all this in hand — diagnosis, weights, priorities, maturity score, and validated feasibility — we have the data needed to identify <strong>quick wins</strong>, find <strong>shared pain points across departments</strong>, map out <strong>the right automations</strong>, and build a <strong>complete roadmap</strong> with cost estimates for deploying each agent. From here, we're ready for the next step."
      ]
    },
    "build": {
      "label": "02  —  BUILD",
      "paragraphs": [
        "For each automation prioritized in the Assessment, we start by connecting your <strong>ERPs, databases, internal systems, and daily tools</strong> to a unified layer that AI agents can read from and act on. All this work is done through <strong>MCP (Model Context Protocol)</strong> interfaces — the open protocol adopted by all major AI providers as the standard for agent-to-system communication.",
        "Each integration created can be <strong>reused by multiple agents</strong>. A connection to your ERP, for example, serves both a financial agent and a logistics one. As we advance, <strong>implementation accelerates</strong> — because the foundation is already built.",
        "With systems connected, we move to <strong>building, documenting, deploying, and validating agents</strong> — always together with end users. Everything is built on <strong>our own platform</strong>, built to be <strong>model- and provider-agnostic</strong>. We default to Anthropic today, but can switch to any provider as needed.",
        "Automations can take different forms: from <strong>autonomous agents with specific roles and personalities</strong>, to <strong>lightweight integrations</strong> triggered via Slack, Teams, email, WhatsApp, or any other channel your team already uses."
      ],
      "note": "Important: all our deliverables — process maps, agent specifications, and prompts — are fully transferable to other platforms. There's no vendor lock-in."
    },
    "operate": {
      "label": "03  —  OPERATE",
      "paragraphs": [
        "Agents in production need <strong>continuous monitoring</strong>. In the Operate phase, we ensure your AI operations evolve constantly — with active monitoring, cost optimization, and agent refinement.",
        "Through our platform, we have full control over <strong>telemetry, cost tracking, model quality monitoring, and A/B testing</strong> of results. We generate detailed <strong>monthly reports</strong> of all automations and operational costs.",
        "You get a <strong>dedicated or shared Agent Engineer</strong> for real-time adjustments and maintenance. As operations mature, we identify new automation opportunities and expand the agent network — creating a <strong>flywheel of continuous improvement</strong>."
      ],
      "note": "Ongoing operations are what separate one-off projects from real transformation. Here, AI stops being an experiment and becomes infrastructure."
    },
    "differentials": {
      "title": "What Sets Us Apart",
      "items": [
        {
          "title": "No model or provider dependency",
          "description": "Our platform is <b>model and provider agnostic</b>. You are protected against token price fluctuations — we can migrate to any available model on the market, always seeking the <b>best cost-benefit</b>, without impacting your automations."
        },
        {
          "title": "Hands-on approach",
          "description": "We're not distant consultants. We're embedded in your operation, finding opportunities and implementing solutions alongside your team."
        },
        {
          "title": "Short cycles, results in weeks",
          "description": "Deliveries in short sprints. Concrete results from the first weeks. No open-ended timelines."
        },
        {
          "title": "Proven experience",
          "description": "30+ projects delivered by Sugar Cane Tech. Founders with 13+ years in software engineering."
        },
        {
          "title": "From diagnosis to implementation",
          "description": "We cover the entire cycle: from finding where AI makes sense to putting agents into production integrated with your systems."
        },
        {
          "title": "Real AI maturity evolution",
          "description": "We use our <b>AI Maturity Scale</b> to measure where your company stands and where it needs to go. Every delivery moves the operation forward on the scale — out of the risk zone into <b>real automation</b>, with measurable results at every stage."
        }
      ]
    },
    "cases": {
      "title": "Successful Cases",
      "items": [
        {
          "label": "CASE 01",
          "name": "Automated Monthly Timesheet Closing with Invoice Generation",
          "logoKey": "scoder",
          "website": "www.scoder.com.br",
          "casePath": "/case-scoder"
        },
        {
          "label": "CASE 02",
          "name": "Smart Lead Updates via Brokers & Clients",
          "logoKey": "jhsf",
          "website": "www.jhsf.com.br",
          "casePath": "/case-jhsf"
        }
      ]
    },
    "contact": {
      "title": "Let's Talk?",
      "heading": "Ready to transform your operation with AI?",
      "email": "contact@bravicglobal.com",
      "webLabel": "Web:",
      "webUrl": "www.bravicglobal.com",
      "button": "Contact",
      "footerText": "by Sugar Cane Tech  |  AI Applied to Your Business"
    }
  },
  "caseScoder": {
    "docLabel": "Case · Scoder Tech Studio · delivered via Sugar Cane Tech",
    "cover": {
      "badge": "Case Study",
      "title": "Automation of",
      "titleAccent": "Monthly Hour Closing",
      "description": "How Scoder Tech Studio, a software house with operations in Brazil and the USA, eliminated 144 hours/month of operational work by automating the cycle of time tracking, validation, billing, and payments for team members assigned to client projects — reducing the process from",
      "descriptionHighlight": "7 days to 1 day",
      "clientLabel": "Client",
      "clientName": "Scoder Tech Studio",
      "clientTagline": "Software house · Brazil & USA"
    },
    "flowchart": {
      "sectionLabel": "01 — Automated Process",
      "title": "Operational Flowchart",
      "subtitle": "Complete end-to-end mapping of the process automated by Bravic, from initial trigger to sending invoices and payment notices.",
      "legendProcess": "Process Step",
      "legendDecision": "Decision",
      "legendLoop": "Wait / Retry",
      "legendYes": "Approved path",
      "legendNo": "Return path"
    },
    "agents": {
      "sectionLabel": "02 — Multi-Agent Architecture",
      "title": "Agent Hierarchy",
      "subtitle": "Organizational structure of the deployed agentic system: a central Orchestrator delegates to 3 specialized Directors, who in turn coordinate 6 operational Sub-Agents.",
      "legendOrchestrator": "Orchestrator",
      "legendDirectors": "Directors",
      "legendSubAgents": "Operational Sub-Agents"
    },
    "integrations": {
      "sectionLabel": "03 — Technology Stack",
      "title": "Integrations",
      "subtitle": "Systems connected by the automation agent during the end-to-end execution of the Monthly Hour Closing process.",
      "items": [
        {
          "icon": "assignment",
          "name": "Jira",
          "role": "Tracking hours worked per professional and project.",
          "tag": "REST API"
        },
        {
          "icon": "table_chart",
          "name": "Google Sheets",
          "role": "Cross-referencing allocations and populating the client hours spreadsheet.",
          "tag": "Sheets API"
        },
        {
          "icon": "chat",
          "name": "Slack",
          "role": "Requesting approvals from team members and managers via direct message.",
          "tag": "Web API"
        },
        {
          "icon": "mail",
          "name": "Google Workspace",
          "role": "Receiving invoices by email and sending final payment notices to clients.",
          "tag": "Gmail API"
        },
        {
          "icon": "folder",
          "name": "Google Drive",
          "role": "Structured storage of validated contractor invoices.",
          "tag": "Drive API"
        },
        {
          "icon": "account_balance",
          "name": "Banco Inter",
          "role": "Automatic generation of payment notices for clients and instant transfers (PIX) to contractors.",
          "tag": "Open Banking"
        },
        {
          "icon": "assured_workload",
          "name": "Government",
          "role": "Automatic issuance of service tax invoices (NFS-e) via the government e-invoicing API.",
          "tag": "GOV API",
          "tagVariant": "gov"
        }
      ]
    },
    "costs": {
      "sectionLabel": "04 — Monthly Investment",
      "title": "Operational Costs",
      "subtitle": "Breakdown of recurring costs to maintain the process automation in production.",
      "costHeader": "Monthly Cost Breakdown",
      "costPill": "1 item · R$ 2,225.00",
      "costTotalLabel": "Total monthly cost",
      "costTotalValue": "R$ 2,225.00",
      "items": [
        {
          "label": "Bravic Operations",
          "detail": "Tokens in/out + Maintenance + SRE",
          "value": "R$ 2,225.00"
        }
      ],
      "roiLabel": "Return on investment",
      "roiTitle": "Net Savings",
      "roiGross": "Gross monthly savings",
      "roiGrossValue": "+ R$ 10,320.00",
      "roiCost": "Operational cost",
      "roiCostValue": "− R$ 2,225.00",
      "roiNetLabel": "Net / month",
      "roiNetValue": "R$ 8,095",
      "roiPercent": "ROI on cost",
      "roiPercentValue": "364%",
      "roiAnnual": "Annual net projection",
      "roiAnnualValue": "R$ 97,140.00"
    },
    "metrics": {
      "sectionLabel": "05 — Measured Results",
      "title": "Automation Impact",
      "subtitle": "Consolidated metrics after the implementation of the automation agent in the Monthly Hour Closing process at Scoder Tech Studio.",
      "cards": [
        {
          "label": "Hours Saved",
          "value": "144",
          "unit": "h/mo",
          "delta": "3 roles freed from operational tasks",
          "accent": "primary"
        },
        {
          "label": "Financial Savings",
          "value": "R$ 10,320",
          "unit": "/mo",
          "delta": "R$ 123,840 projected/year",
          "accent": "success"
        },
        {
          "label": "Process Time",
          "value": "7 → 1",
          "unit": "day",
          "delta": "↓ 86% reduction in cycle time",
          "accent": "warning"
        },
        {
          "label": "Management Visibility",
          "value": "Automated Reports",
          "delta": "Analysis by employee and project",
          "accent": "info",
          "smallValue": true
        }
      ],
      "breakdownTitle": "Breakdown · Hours Freed by Role",
      "breakdownPill": "144h · R$ 10,320.00 / month",
      "breakdownHoursLabel": "Hours/mo",
      "breakdownRateLabel": "Cost/hour",
      "breakdownFooter": "Consolidated monthly savings",
      "breakdownFooterValue": "R$ 10,320.00",
      "breakdownItems": [
        {
          "role": "Financial Assistant",
          "hours": "84h",
          "rate": "R$ 30.00",
          "total": "R$ 2,520.00"
        },
        {
          "role": "Project Manager",
          "hours": "40h",
          "rate": "R$ 80.00",
          "total": "R$ 3,200.00"
        },
        {
          "role": "Operations Director",
          "hours": "20h",
          "rate": "R$ 230.00",
          "total": "R$ 4,600.00"
        }
      ]
    },
    "footer": {
      "creditLabel": "Developed by",
      "creditText": "Sugar Cane Tech (delivered before Bravic, by the founding team)",
      "reportVersion": "Report v1.4 · Scoder Case · March 2026",
      "page": "Page"
    },
    "flow": {
      "step1Line1": "Fetch total hours per",
      "step1Line2": "team member per project",
      "step2Line1": "Verify consistency with",
      "step2Line2": "the allocation spreadsheet",
      "step3Line1": "Request approval",
      "step3Line2": "from team member",
      "decision1Line1": "All",
      "decision1Line2": "approved?",
      "loopWait": "WAIT",
      "loopTime": "1H",
      "no": "NO",
      "yes": "YES",
      "r1Line1": "Receive Invoice",
      "r1Line2": "via E-mail",
      "r2Line1": "Validate and Save",
      "r2Line2": "to Drive",
      "r3Line1": "Validate deductions",
      "r3Line2": "and generate PIX",
      "l1Line1": "Populate the Client",
      "l1Line2": "Hours Spreadsheet",
      "l2Line1": "Generate Invoice",
      "decision2Line1": "Manager",
      "decision2Line2": "Approved?",
      "loop2Line1": "Tell the agent",
      "loop2Line2": "what to",
      "loop2Line3": "revise or",
      "loop2Line4": "restart",
      "l3Line1": "Draft E-mails",
      "l4Line1": "Generate Payment Notice",
      "l5Line1": "Generate NFS-e",
      "finalLine1": "Send E-mails with",
      "finalLine2": "payment notice and NFS-e"
    },
    "agentFlow": {
      "orchestratorTag": "ORCHESTRATOR",
      "orchestratorLine1": "Orchestrator",
      "orchestratorLine2": "Agent",
      "directorTag": "DIRECTOR",
      "dirTechLine1": "Technology",
      "dirTechLine2": "Director",
      "dirFinLine1": "Financial Director",
      "dirDelLine1": "Delivery",
      "dirDelLine2": "Director",
      "subAgentTag": "SUB-AGENT",
      "subPmLine1": "Project",
      "subPmLine2": "Manager",
      "subTechLine1": "Tech Lead",
      "subApLine1": "Accounts",
      "subApLine2": "Payable",
      "subArLine1": "Accounts",
      "subArLine2": "Receivable",
      "subFinLine1": "Financial",
      "subFinLine2": "Assistant",
      "subDelLine1": "Deliveries"
    }
  },
  "caseJhsf": {
    "docLabel": "Case · JHSF Participações · delivered via Sugar Cane Tech",
    "cover": {
      "badge": "CRM Automation • Real Estate",
      "title": "Smart",
      "titleAccent": "Lead",
      "titleLine2": "Updates via Brokers & Clients",
      "description": "Automatic orchestration with two parallel tracks: broker feedback collection (via audio/text) and client satisfaction survey (quick questions) — both feeding Salesforce to enrich leads and recalculate scores in real time.",
      "clientLabel": "Client",
      "clientName": "JHSF Participações",
      "clientTagline": "Real Estate & Hospitality • High End",
      "clientLink": "jhsf.com.br"
    },
    "flowchart": {
      "sectionLabel": "Operational Flow",
      "title": "Lead Update Flowchart",
      "subtitle": "Automatic orchestration with two parallel tracks: broker feedback collection and client satisfaction survey, converging to recalculate the lead score in Salesforce.",
      "legendProcess": "Process / Action",
      "legendDecision": "Decision",
      "legendLoop": "Wait / Retry",
      "legendYes": "Positive path",
      "legendNo": "Negative path"
    },
    "integrations": {
      "sectionLabel": "Ecosystem",
      "title": "Integrations & Systems",
      "subtitle": "Connected tool stack orchestrated by the agent for the end-to-end flow of data collection, processing, and updating.",
      "items": [
        {
          "icon": "database",
          "name": "Salesforce CRM",
          "role": "Bookings, lead management, visit records, and lead scoring",
          "tag": "CRM",
          "tagVariant": "crm"
        },
        {
          "icon": "chat",
          "name": "WhatsApp Business",
          "role": "Broker feedback collection (audio/text) and post-visit client satisfaction survey",
          "tag": "Messaging",
          "tagVariant": "msg"
        },
        {
          "icon": "bar_chart",
          "name": "Lead Scoring Engine",
          "role": "Automatic score recalculation combining broker feedback and client satisfaction",
          "tag": "CRM",
          "tagVariant": "crm"
        },
        {
          "icon": "star",
          "name": "NPS & Satisfaction",
          "role": "Quick post-visit survey where the client rates the broker, property, and overall experience",
          "tag": "Survey",
          "tagVariant": "survey"
        },
        {
          "icon": "sentiment_satisfied",
          "name": "Sentiment Analysis",
          "role": "Processes open-ended client responses and broker audio to extract sentiment and insights",
          "tag": "AI",
          "tagVariant": "llm"
        },
        {
          "icon": "notifications",
          "name": "Smart Alerts",
          "role": "Automatic notifications to managers when score changes or NPS is critical",
          "tag": "Messaging",
          "tagVariant": "msg"
        }
      ]
    },
    "metrics": {
      "sectionLabel": "Impact",
      "title": "Result Metrics",
      "subtitle": "Projected results after 90 days of agentic operations in the JHSF sales funnel.",
      "cards": [
        {
          "label": "Visit Record Rate",
          "value": "97",
          "unit": "%",
          "delta": "Before: 38% of visits recorded",
          "accent": "primary"
        },
        {
          "label": "Avg Update Time",
          "value": "< 4",
          "unit": "hrs",
          "delta": "Before: 3-5 days (when recorded)",
          "accent": "success"
        },
        {
          "label": "Hours/Month Saved",
          "value": "120",
          "unit": "hrs",
          "delta": "Team of 15 brokers",
          "accent": "warning"
        },
        {
          "label": "Lead Score Accuracy",
          "value": "+42",
          "unit": "%",
          "delta": "Real data vs. manual estimates",
          "accent": "info"
        },
        {
          "label": "Client Response Rate",
          "value": "72",
          "unit": "%",
          "delta": "Before: 0% (no survey existed)",
          "accent": "primary"
        },
        {
          "label": "NPS Captured",
          "value": "78",
          "unit": "pts",
          "delta": "Real-time satisfaction view",
          "accent": "success"
        },
        {
          "label": "Leads with Dual Feedback",
          "value": "68",
          "unit": "%",
          "delta": "Broker + client feedback combined",
          "accent": "warning"
        },
        {
          "label": "Critical Alerts Detected",
          "value": "23",
          "unit": "/month",
          "delta": "At-risk clients caught in time",
          "accent": "info"
        }
      ]
    },
    "agents": {
      "sectionLabel": "Architecture",
      "title": "Agent Structure",
      "subtitle": "Multi-agent hierarchy: the Orchestrator monitors Salesforce Booking, the Director coordinates two parallel tracks (broker and client), and 5 specialized sub-agents execute each step.",
      "legendOrchestrator": "Orchestrator — monitors triggers",
      "legendDirectors": "Director — coordinates pipeline",
      "legendSubAgents": "Sub-agent — executes specific task"
    },
    "footer": {
      "creditLabel": "Developed by",
      "creditText": "JHSF — Commercial Intelligence",
      "reportVersion": "v1.0 • April 2026 • JHSF Case",
      "page": "Page"
    },
    "flow": {
      "triggerBadge": "TRIGGER • BOOKING DETECTED",
      "triggerLine1": "Identify booking",
      "triggerLine2": "in Salesforce Booking",
      "waitLabel1": "WAIT",
      "waitLabel2": "END OF DAY",
      "laneA": "TRACK A • BROKER FEEDBACK",
      "laneB": "TRACK B • CLIENT FEEDBACK",
      "a1Badge": "WHATSAPP",
      "a1Line1": "Request audio or message",
      "a1Line2": "describing the visit",
      "a1DecisionLine1": "Broker",
      "a1DecisionLine2": "responded?",
      "a1WaitLabel1": "WAIT",
      "a1WaitLabel2": "2H",
      "a1RetryNote": "Max 2 attempts",
      "a2Badge": "AI AGENT",
      "a2Line1": "Transcribe audio and interpret",
      "a2Line2": "broker feedback via AI",
      "a3Line1": "Generate structured visit",
      "a3Line2": "record in the CRM",
      "a4Line1": "Update Lead data",
      "a4Line2": "with visit details",
      "extractLabel": "EXTRACTS",
      "extractLine1": "Interest, objections",
      "extractLine2": "sentiment, profile",
      "b1Badge": "WHATSAPP",
      "b1Line1": "Send quick questions",
      "b1Line2": "to client post-visit",
      "b1QuestionsLabel": "QUESTIONS",
      "b1Q1": "1. Visit rating",
      "b1Q2": "2. Property rating",
      "b1Q3": "3. Interest in revisit",
      "b1Q4": "4. Free comment",
      "b1DecisionLine1": "Client",
      "b1DecisionLine2": "responded?",
      "b1WaitLabel1": "REMINDER",
      "b1WaitLabel2": "24H",
      "b2Badge": "AI AGENT",
      "b2Line1": "Analyze sentiment and",
      "b2Line2": "categorize client responses",
      "b3Line1": "Record client evaluation",
      "b3Line2": "in the Lead profile",
      "b4Line1": "Update NPS and",
      "b4Line2": "Lead satisfaction index",
      "b3AnnotLabel": "SAVES TO CRM",
      "b3AnnotLine1": "Broker rating, property rating",
      "b3AnnotLine2": "NPS, comments",
      "mergeLabel": "CONSOLIDATED DATA",
      "scoreLine1": "Recalculate Lead Score",
      "scoreLine2": "with combined data",
      "scoreDecisionLine1": "Score changed",
      "scoreDecisionLine2": "significantly?",
      "notifyLine1": "Notify sales manager",
      "notifyLine2": "about lead score change",
      "silentLine1": "Score updated",
      "silentLine2": "silently in the CRM",
      "endLabel": "FLOW COMPLETED",
      "bookingAnnotLabel": "BOOKING DATA",
      "bookingAnnotLine": "Date, time, property, broker, client",
      "msgAnnotLabel": "BROKER MSG",
      "msgAnnotLine": "\"How was the visit?\""
    },
    "agentFlow": {
      "orchestratorRole": "ORCHESTRATOR",
      "orchestratorName": "Booking Monitor Agent",
      "directorRole": "DIRECTOR",
      "directorName": "Lead Enrichment Director",
      "laneCorretorLabel": "BROKER TRACK",
      "laneClienteLabel": "CLIENT TRACK",
      "sub1Role": "SUB-AGENT",
      "sub1Name": "Broker Collector",
      "sub1Desc": "Collects broker feedback",
      "sub2Role": "SUB-AGENT",
      "sub2Name": "Audio Processor",
      "sub2Desc": "Transcribes and interprets audio",
      "sub3Role": "SUB-AGENT",
      "sub3Name": "CRM Writer",
      "sub3Desc": "Records everything in Salesforce",
      "sub4Role": "SUB-AGENT",
      "sub4Name": "Client Surveyor",
      "sub4Desc": "Post-visit client survey",
      "sub5Role": "SUB-AGENT",
      "sub5Name": "Score Calculator",
      "sub5Desc": "Recalculates lead score",
      "tech1": "WhatsApp Business API",
      "tech2": "Audio + NLP Engine",
      "tech3": "Salesforce API",
      "tech4": "WhatsApp + NPS",
      "tech5": "Custom Scoring Model",
      "flowLine1": "Track A: Booking → End of day → WhatsApp broker → Transcribe audio → Record visit",
      "flowLine2": "Track B: Booking → End of day → Quick client questions → NPS evaluation → Combine data → Recalculate Score"
    }
  },
  "logoStrip": {
    "label": "Work delivered by this team",
    "clients": [
      {
        "name": "SIS Segurança Privada",
        "relation": "Bravic pilot"
      },
      {
        "name": "Newave Capital",
        "relation": "Bravic pilot"
      },
      {
        "name": "JHSF Participações",
        "relation": "via Sugar Cane Tech"
      },
      {
        "name": "Scoder Tech Studio",
        "relation": "via Sugar Cane Tech"
      }
    ]
  },
  "platform": {
    "label": "Differentiator",
    "headingPrefix": "",
    "headingSuffix": " Technology",
    "lede": "Proprietary enterprise agent orchestration technology, built in-house to give us control over what matters most: security, integrations, observability, compliance, and continuous evolution.",
    "lede2": "This is the foundation on which every agent is designed, connected to client systems, and monitored in production.",
    "lede3": "We don't depend on a third-party tool's roadmap. The same team that builds the solution also controls the platform, the architecture, and the technical evolution behind it.",
    "pillars": [
      {
        "title": "Proprietary by choice",
        "description": "The Bravic Platform was built in-house so each implementation gets more control, flexibility, and technical depth. We adapt integrations, rules, flows, and security layers to each client's reality — without depending on the limitations or priorities of an external platform."
      },
      {
        "title": "Model-agnostic",
        "description": "OpenAI, Anthropic, Google, and open-source models can be evaluated case by case, considering performance, cost, security, and process fit. When the best model changes, the platform changes with it — without rebuilding the entire operation."
      },
      {
        "title": "Horizontal foundation",
        "description": "The first implementation creates the technical foundation of the operation: integrations, infrastructure, permissions, rules, and governance. From this foundation, new agents and use cases can be activated faster, more predictably, and with less incremental effort. The second agent doesn't start from scratch."
      },
      {
        "title": "Enterprise architecture",
        "description": "With a modern stack, documentation, environment separation, and an audit-ready structure, the platform supports sensitive integrations, compliance validations, and formal partnerships with AI providers."
      }
    ]
  },
  "trust": {
    "label": "Governance",
    "heading": "Enterprise AI Agents aligned with compliance.",
    "description": "Bravic designs every orchestration considering internal policies, compliance requirements, security criteria, traceability, access permissions, and approval processes. The intelligence operates within the boundaries defined by the organization.",
    "items": [
      {
        "icon": "rule",
        "title": "Compliance by design",
        "description": "Agent orchestration is designed from your company's rules, policies, and approval criteria."
      },
      {
        "icon": "security",
        "title": "Operational security",
        "description": "Every agent is built to operate with access control, environment separation, logs, traceability, and validations before interacting with critical systems.\n\nAI doesn't act as a black box. Every action must be visible, auditable, and governed."
      },
      {
        "icon": "science",
        "title": "Controlled environments",
        "description": "Every integration starts in a sandbox, with isolated testing and clear criteria for promotion to production. No agent touches the real operation without technical validation."
      },
      {
        "icon": "fact_check",
        "title": "Audit",
        "description": "Architecture, flows, integrations, and control points are documented to support internal reviews, audits, and validation with IT, legal, security, and compliance teams."
      }
    ],
    "cta": {
      "description": "Do you have specific compliance or security requirements? Let's design the orchestration that meets your standard together.",
      "button": "Talk to Bravic"
    }
  },
  "seo": {
    "tagline": "Intelligence that operates",
    "defaultDescription": "Bravic is a model-agnostic Enterprise Agent Platform. From Assessment to Operate, we put AI agents in production within 4 weeks, with an embedded Agent Engineer.",
    "home": {
      "title": "Enterprise AI agent orchestration",
      "description": "Model-agnostic AI agent platform plus an embedded Agent Engineer. From strategic assessment to continuous operation, with real integrations into your ERP, CRM and internal systems."
    },
    "manifesto": {
      "title": "Manifesto",
      "description": "What we believe about applied AI for enterprise operations: orchestration as product, a model-agnostic platform, and continuous operation as a non-negotiable."
    },
    "about": {
      "title": "Who we are",
      "description": "Meet Bravic's founders and team — engineers, operators and strategists putting AI agents in production for enterprise clients."
    },
    "roadmap": {
      "title": "What we do: Assessment, Build, Operate",
      "description": "Three phases to put AI into production. Assessment delivers an AI Score and business case. Build ships agents integrated with your ERP/CRM. Operate is continuous refinement with an embedded Agent Engineer."
    },
    "contact": {
      "title": "Talk to Bravic",
      "description": "Book an Assessment or talk to our team. We respond within one business day."
    },
    "institucional": {
      "title": "Company overview",
      "description": "Bravic in full: positioning, platform, operating model, cases, and methodology."
    },
    "caseScoder": {
      "title": "Scoder case — 144h/month eliminated in closing",
      "description": "How Bravic replaced Scoder's manual closing process with ERP-connected AI agents, removing 144 operational hours per month."
    },
    "caseJhsf": {
      "title": "JHSF case — service logging from 38% to 97%",
      "description": "How Bravic raised JHSF Participações' service logging from 38% to 97% with CRM-integrated agent orchestration."
    },
    "privacy": {
      "title": "Privacy Policy",
      "description": "How Bravic collects, uses, stores and protects personal data and data accessed via Google and Microsoft integrations (profile, email, Google Drive, OneDrive and SharePoint)."
    },
    "terms": {
      "title": "Terms of Use",
      "description": "Terms and conditions for using Bravic's services, platform and website, including access rules, intellectual property and responsibilities."
    }
  },
  "legal": {
    "common": {
      "lastUpdatedLabel": "Last updated",
      "tocLabel": "Contents",
      "backToTop": "Back to top"
    },
    "privacy": {
      "title": "Privacy Policy",
      "lastUpdated": "May 9, 2026",
      "intro": [
        "This Privacy Policy describes how <strong>Bravic</strong> (\"Bravic\", \"we\"), collects, uses, stores, shares and protects personal data in connection with our services, our AI agent orchestration platform, and this website (<a href=\"https://bravicglobal.com\">bravicglobal.com</a>).",
        "This Policy also describes how we handle data accessed from Google and Microsoft accounts when the customer authorizes Bravic to integrate with such services through OAuth 2.0. Processing complies with Brazil's General Data Protection Law (Law No. 13,709/2018 — LGPD), the Brazilian Internet Civil Framework (Law No. 12,965/2014), the Google API Services User Data Policy (including its Limited Use requirements) and the Microsoft Graph API terms.",
        "By using our services or authorizing the integration with Google and/or Microsoft, you confirm that you have read and accepted this Policy."
      ],
      "sections": [
        {
          "id": "controller",
          "title": "1. Controller and Data Protection Officer (DPO)",
          "paragraphs": [
            "<strong>Controller:</strong> Bravic.",
            "<strong>Data Protection Officer (DPO):</strong> dpo@bravicglobal.com.",
            "For any questions, data subject requests or privacy-related communications, please use <a href=\"mailto:privacy@bravicglobal.com\">privacy@bravicglobal.com</a>."
          ]
        },
        {
          "id": "scope",
          "title": "2. Scope",
          "paragraphs": [
            "This Policy applies to: (i) Bravic's website; (ii) the Bravic Platform (Enterprise Agent Platform) and the AI agents we operate in production; (iii) integrations with third-party services authorized by the customer, including Google Workspace (Drive, email, profile) and Microsoft 365 (OneDrive, SharePoint, profile)."
          ]
        },
        {
          "id": "data-we-collect",
          "title": "3. Data we collect",
          "paragraphs": [
            "<strong>3.1 Data you provide directly.</strong> Name, business email, phone number, company, role and message, when you submit contact forms, schedule an Assessment or sign up to the Bravic Platform.",
            "<strong>3.2 Data collected automatically.</strong> IP address, device identifiers, browser type, operating system, pages visited, date and time of access, referrer, and data from strictly necessary and analytics cookies.",
            "<strong>3.3 Data accessed via Google OAuth.</strong> When the customer authorizes it, Bravic accesses: (a) <em>basic profile and email</em> (scopes <code>openid</code>, <code>profile</code>, <code>email</code>) — name, email address, account identifier and profile picture, used for authentication and user identification; (b) <em>Google Drive</em> (scopes such as <code>drive.file</code>, <code>drive.readonly</code> or <code>drive</code>, depending on the authorized use case) — read, create or organize files and metadata strictly necessary for the contracted automation.",
            "<strong>3.4 Data accessed via Microsoft OAuth (Microsoft Graph).</strong> When the customer authorizes it, Bravic accesses: (a) <em>basic profile</em> (scope <code>User.Read</code>) — name, email and account identifier; (b) <em>OneDrive and SharePoint</em> (scopes such as <code>Files.Read</code>, <code>Files.ReadWrite</code>, <code>Sites.Read.All</code>, <code>Sites.ReadWrite.All</code>, depending on the authorized use case) — read, create or organize files, sites and document libraries strictly necessary for the contracted automation.",
            "<strong>3.5 Agent operation data.</strong> Execution logs, prompts, responses, quality metrics, cost per token, exceptions and audit trails, used to operate, monitor and improve the contracted agents.",
            "We do not collect sensitive data (racial origin, political opinion, religion, health, biometrics, etc.) unless strictly necessary and expressly authorized by the customer in a specific agreement."
          ]
        },
        {
          "id": "google-limited-use",
          "title": "4. Use of Google data (Google API Services User Data Policy)",
          "paragraphs": [
            "Bravic's use of information received from Google APIs adheres to the <a href=\"https://developers.google.com/terms/api-services-user-data-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Google API Services User Data Policy</a>, including the <strong>Limited Use</strong> requirements. Specifically:",
            "<ul><li>we use data accessed via Google APIs <strong>only</strong> to provide and improve the automation features contracted by the customer that granted access;</li><li>we <strong>do not</strong> use data from Google Workspace APIs (including Gmail, Drive, Calendar and Contacts) to develop, train or improve generalized or non-personalized AI/ML models;</li><li>we <strong>do not</strong> transfer such data to third parties, except (i) as strictly necessary to provide and improve the contracted service, (ii) where required by law, or (iii) with the user's express and specific consent;</li><li>we <strong>do not</strong> use such data for advertising, including targeted or interest-based advertising;</li><li>we <strong>do not</strong> allow humans to read such data, except (i) with the user's express and specific consent, (ii) where necessary for security purposes (e.g., to investigate abuse), (iii) to comply with applicable law, or (iv) where the data has been aggregated and is used for internal operations.</li></ul>"
          ]
        },
        {
          "id": "microsoft-data",
          "title": "5. Use of Microsoft data (Microsoft Graph)",
          "paragraphs": [
            "We process data accessed via Microsoft Graph in accordance with the <a href=\"https://learn.microsoft.com/graph/security-concept-overview\" target=\"_blank\" rel=\"noopener noreferrer\">Microsoft platform terms</a> and with the privacy principles described herein. Specifically:",
            "<ul><li>we use OneDrive, SharePoint and profile data <strong>only</strong> to deliver the automation contracted by the customer that granted access;</li><li>we <strong>do not</strong> use such data to train generalized AI/ML models, nor for advertising;</li><li>we follow the principle of least privilege — we request only the scopes necessary for the authorized use case;</li><li>the customer can revoke access at any time through Microsoft (My Account → Apps & services) or through tenant administration settings.</li></ul>"
          ]
        },
        {
          "id": "purposes",
          "title": "6. Purposes and legal bases",
          "paragraphs": [
            "We process personal data for the following purposes, on the following legal bases (LGPD, art. 7):",
            "<ul><li><strong>Performance of contract and pre-contractual procedures</strong> (art. 7, V): authenticating users, operating production agents, executing authorized integrations and providing support;</li><li><strong>Compliance with legal and regulatory obligations</strong> (art. 7, II): LGPD compliance, tax, accounting and fraud-prevention rules;</li><li><strong>Legitimate interest</strong> (art. 7, IX): information security, abuse prevention, continuous service improvement and B2B institutional communication aligned with the data subject's reasonable expectation;</li><li><strong>Consent</strong> (art. 7, I): opt-in marketing communications and non-essential cookies;</li><li><strong>Regular exercise of rights</strong> (art. 7, VI): in judicial, administrative or arbitral proceedings.</li></ul>"
          ]
        },
        {
          "id": "sharing",
          "title": "7. Sharing and processors (sub-processors)",
          "paragraphs": [
            "Bravic shares personal data only when necessary, with:",
            "<ul><li><strong>Infrastructure providers</strong> (cloud, hosting, observability): to host the Platform and process customer data;</li><li><strong>AI model providers</strong> (Anthropic, OpenAI, Google, among others): as authorized by the customer and in accordance with each provider's retention and training settings;</li><li><strong>Operational tools</strong> (transactional email, CRM, support): exclusively to operate the contractual relationship;</li><li><strong>Public authorities</strong>: when required by law, judicial order or to defend rights.</li></ul>",
            "We do not sell personal data. We maintain an updated list of sub-processors, available upon request to the DPO."
          ]
        },
        {
          "id": "transfers",
          "title": "8. International transfers",
          "paragraphs": [
            "Some sub-processors are located outside Brazil. Whenever there is an international transfer, we ensure the safeguards required by article 33 of the LGPD, including standard contractual clauses and adequacy under equivalent regimes."
          ]
        },
        {
          "id": "retention",
          "title": "9. Retention and deletion",
          "paragraphs": [
            "We retain personal data only as long as necessary for the purposes for which it was collected or as required by law. In general: business contact data for up to 5 years after last contact; agent operational data and logs for the term defined in the customer agreement; analytics cookies for up to 13 months.",
            "Upon contract termination or withdrawal of consent, we delete or anonymize the data, except where retention is required by legal duty."
          ]
        },
        {
          "id": "security",
          "title": "10. Information security",
          "paragraphs": [
            "We adopt technical and organizational measures consistent with the state of the art, including: encryption in transit (TLS 1.2+) and at rest, role-based access control (RBAC), environment segregation, principle of least privilege, audit logging, secrets management, code review and incident response.",
            "In the event of a security incident that may pose relevant risk or harm to data subjects, we will notify the ANPD (Brazilian DPA) and affected data subjects within a reasonable period, in accordance with article 48 of the LGPD."
          ]
        },
        {
          "id": "cookies",
          "title": "11. Cookies",
          "paragraphs": [
            "We use strictly necessary cookies (authentication, security), preference cookies (language) and analytics cookies to understand site usage. You can block or delete cookies through your browser settings. Blocking essential cookies may impair site functionality."
          ]
        },
        {
          "id": "rights",
          "title": "12. Data subject rights",
          "paragraphs": [
            "Under article 18 of the LGPD (and articles 15–22 of the GDPR, where applicable), you have the right to: confirmation of the existence of processing; access to data; correction of incomplete, inaccurate or outdated data; anonymization, blocking or deletion of unnecessary or unlawfully processed data; portability; deletion of data processed on the basis of consent; information about sharing; withdrawal of consent; and objection to processing carried out under other legal bases.",
            "To exercise any right, please write to <a href=\"mailto:privacy@bravicglobal.com\">privacy@bravicglobal.com</a>. We will respond within 15 days.",
            "<strong>Revoking access to Google/Microsoft:</strong> you may revoke the authorization granted to Bravic at any time at <a href=\"https://myaccount.google.com/permissions\" target=\"_blank\" rel=\"noopener noreferrer\">myaccount.google.com/permissions</a> (Google) or <a href=\"https://myaccount.microsoft.com/\" target=\"_blank\" rel=\"noopener noreferrer\">myaccount.microsoft.com</a> (Microsoft)."
          ]
        },
        {
          "id": "children",
          "title": "13. Children",
          "paragraphs": [
            "Our services are B2B and intended for professionals over 18. We do not knowingly collect data from children. If we identify any improper collection, we will delete the data immediately."
          ]
        },
        {
          "id": "updates",
          "title": "14. Changes to this Policy",
          "paragraphs": [
            "We may update this Policy to reflect legal, technical or operational changes. The current version is the one published on this page, with the \"Last updated\" date shown above. Material changes will be communicated in advance through registered channels."
          ]
        },
        {
          "id": "contact",
          "title": "15. Contact",
          "paragraphs": [
            "Questions, data subject requests or privacy communications: <a href=\"mailto:privacy@bravicglobal.com\">privacy@bravicglobal.com</a>.",
            "You may also file a complaint with the Brazilian Data Protection Authority (ANPD) at <a href=\"https://www.gov.br/anpd\" target=\"_blank\" rel=\"noopener noreferrer\">gov.br/anpd</a>."
          ]
        }
      ]
    },
    "terms": {
      "title": "Terms of Use",
      "lastUpdated": "May 9, 2026",
      "intro": [
        "These Terms of Use (\"Terms\") govern access to and use of the services, platform and website of <strong>BRavic</strong>, (\"Bravic\", \"we\"), including the Bravic Platform (Enterprise Agent Platform) and the website <a href=\"https://bravicglobal.com\">bravicglobal.com</a>.",
        "By accessing, browsing or contracting our services, you (\"User\" or \"Customer\") confirm that you have read, understood and accepted these Terms in full and our <a href=\"/privacy\">Privacy Policy</a>. If you do not agree, do not use the services."
      ],
      "sections": [
        {
          "id": "definitions",
          "title": "1. Definitions",
          "paragraphs": [
            "<strong>Platform:</strong> Bravic's proprietary environment for orchestrating AI agents connected to the Customer's systems.",
            "<strong>Agent:</strong> a system based on language models, business rules and integrations, executed by the Platform under the supervision of Bravic's Agent Engineer.",
            "<strong>Services:</strong> Assessment, Build, Operate, access to the Platform, and any other deliverables defined in a specific agreement (\"Agreement\")."
          ]
        },
        {
          "id": "eligibility",
          "title": "2. Eligibility",
          "paragraphs": [
            "The Services are intended exclusively for legal entities and professionals over 18 with capacity to contract. By accepting these Terms on behalf of a company, you represent that you have authority to bind it."
          ]
        },
        {
          "id": "account",
          "title": "3. Registration and account",
          "paragraphs": [
            "To use the Platform, the Customer must provide truthful, complete and up-to-date information. The Customer is responsible for the confidentiality of credentials and for all activities performed under its account. In case of unauthorized use, please notify <a href=\"mailto:security@bravicglobal.com\">security@bravicglobal.com</a> immediately."
          ]
        },
        {
          "id": "license",
          "title": "4. License",
          "paragraphs": [
            "Subject to compliance with these Terms and the Agreement, Bravic grants the Customer a limited, non-exclusive, non-transferable and revocable license to access and use the Platform and contracted Agents, solely for the Customer's internal operations during the contract term."
          ]
        },
        {
          "id": "acceptable-use",
          "title": "5. Acceptable use",
          "paragraphs": [
            "The User shall not:",
            "<ul><li>use the Platform for unlawful or fraudulent purposes or in a way that infringes third-party rights;</li><li>attempt to access restricted areas, circumvent security measures, reverse-engineer or decompile the Platform;</li><li>introduce malware, malicious code or perform attacks of any kind;</li><li>use the Platform to generate content prohibited by law, including discriminatory, violent, child sexual content or content that infringes intellectual property rights;</li><li>resell, sublicense or make the Services available to third parties without express authorization;</li><li>scrape data in an automated manner that compromises the integrity or availability of the Services.</li></ul>"
          ]
        },
        {
          "id": "client-data",
          "title": "6. Customer data and third-party integrations",
          "paragraphs": [
            "The Customer is the controller of the personal data it makes available to Bravic and is responsible for the lawfulness of collection and sharing. Bravic acts as a processor, in accordance with the Agreement, this Policy, the LGPD and the terms of the integrated platforms (Google, Microsoft, etc.).",
            "By connecting Google or Microsoft accounts to the Platform, the Customer authorizes Bravic to access the OAuth scopes requested and described in the <a href=\"/privacy\">Privacy Policy</a>, exclusively for the contracted purpose. The Customer may revoke access at any time."
          ]
        },
        {
          "id": "ip",
          "title": "7. Intellectual property",
          "paragraphs": [
            "All intellectual property rights in the Platform, its architecture, source code, trademarks, visual identity, documentation and derivative materials are the exclusive property of Bravic or its licensors. Nothing in these Terms transfers any such rights to the Customer, except for the limited license described in clause 4."
          ]
        },
        {
          "id": "third-parties",
          "title": "8. Third-party services",
          "paragraphs": [
            "The Platform may integrate with third-party services (AI models, cloud providers, Google Workspace, Microsoft 365, Customer's internal systems). Bravic is not responsible for unavailability, failures, or changes to terms or policies of such third parties. Use of those services is subject to their respective terms."
          ]
        },
        {
          "id": "fees",
          "title": "9. Fees and payment",
          "paragraphs": [
            "Fees, payment terms, adjustments and applicable taxes are defined in a specific Agreement. Late payment may result in suspension of access and contractual late charges."
          ]
        },
        {
          "id": "warranties",
          "title": "10. Warranties and availability",
          "paragraphs": [
            "Bravic uses commercially reasonable efforts to keep the Platform available and secure, in accordance with the SLA defined in the Agreement. The Services are provided \"as is\" with respect to aspects not covered by the SLA, and Bravic does not guarantee that the Services will be error-free or uninterrupted."
          ]
        },
        {
          "id": "liability",
          "title": "11. Limitation of liability",
          "paragraphs": [
            "To the maximum extent permitted by applicable law, Bravic's total liability is limited, in any event, to the amount actually paid by the Customer in the 12 months preceding the event giving rise to liability. Bravic is not liable for indirect damages, loss of profits, loss of opportunity, loss of data or business interruption."
          ]
        },
        {
          "id": "termination",
          "title": "12. Term and termination",
          "paragraphs": [
            "These Terms are effective for as long as the Customer uses the Services. Bravic may suspend or terminate access in case of breach of these Terms or the Agreement, judicial order, or threat to the security of the Platform. Provisions relating to intellectual property, confidentiality, limitation of liability and forum survive termination."
          ]
        },
        {
          "id": "changes",
          "title": "13. Changes",
          "paragraphs": [
            "Bravic may update these Terms at any time. The current version is the one published on this page, with the \"Last updated\" date shown above. Material changes will be communicated in advance through registered channels, except as otherwise provided in the specific Agreement."
          ]
        },
        {
          "id": "law",
          "title": "14. Governing law and forum",
          "paragraphs": [
            "These Terms are governed by the laws of the Federative Republic of Brazil. The courts of the District of São Paulo/SP are elected to settle any disputes, with waiver of any other, however privileged, except as otherwise provided in the specific Agreement."
          ]
        },
        {
          "id": "contact",
          "title": "15. Contact",
          "paragraphs": [
            "Questions about these Terms: <a href=\"mailto:contact@bravicglobal.com\">contact@bravicglobal.com</a>."
          ]
        }
      ]
    }
  },
  "notFound": {
    "title": "Page not found",
    "heading": "This page is offline.",
    "description": "The link may be outdated or the content was moved. Go back to the home page to continue.",
    "cta": "Back to home"
  }
}
